import { Injectable, inject } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { Store } from "@ngxs/store";
import { LOGIN_PATH, PASSWORD_CHANGE } from "@sdk/lib/values/shared-paths";
import { PatientProfile } from "@sdk/lib/types/profile";
import { AuthService } from "@auth0/auth0-angular";
import { ProfileState } from "../states/profile.state";

@Injectable({
  providedIn: "root",
})
export class HasChangedPasswordGuard implements CanActivate {
  private _router = inject(Router);
  private _auth = inject(AuthService);
  private _store = inject(Store);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._auth.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          void this._router.navigate(["/", LOGIN_PATH]);
          return [false];
        }
        return this._store.select(ProfileState as any).pipe(
          filter((profile: PatientProfile) => !!profile),
          take(1),
          map((profile: PatientProfile) => {
            if (!profile?.role_list || profile.has_changed_initial_password === true) {
              return true;
            } else {
              void this._router.navigate([`/${PASSWORD_CHANGE}`]);
              return false;
            }
          }),
        );
      }),
    );
  }
}
